var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconChatApprove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 12.6667C11.848 12.6667 13.1053 12.6667 13.886 11.8853C14.6673 11.1047 14.6673 9.84733 14.6673 7.33333C14.6673 4.81933 14.6673 3.562 13.886 2.78133C13.1053 2 11.848 2 9.33398 2H6.66732C4.15332 2 2.89598 2 2.11532 2.78133C1.33398 3.562 1.33398 4.81933 1.33398 7.33333C1.33398 9.84733 1.33398 11.1047 2.11532 11.8853C2.55065 12.3213 3.13398 12.514 4.00065 12.5987",
    stroke: "#EEF3F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7.33333L7.5 8.66667L10 6",
    stroke: "#EEF3F1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33349 12.668C8.50949 12.668 7.60149 13.0013 6.77283 13.4313C5.44083 14.1226 4.77483 14.4686 4.44683 14.248C4.11883 14.028 4.18083 13.3446 4.30549 11.9786L4.33349 11.668",
    stroke: "#EEF3F1",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChatApprove);
export default __webpack_public_path__ + "static/media/IconChatApprove.ebe9f7371a9311715ea1e9509fcb1990.svg";
export { ForwardRef as ReactComponent };